import importerSelectors from 'modules/shared/importer/importerSelectors';

export default importerSelectors(
  'buildingLevel1.importer',
);
